import React from "react";
import { Truck, ShieldCheck, Sparkles, Heart } from "lucide-react";
import { useGlobalData } from "../context/globalContext";

const AboutUs = () => {
  const  websiteDetails  = useGlobalData();
  const webDetails = websiteDetails.websiteDetails
  const features = [
    {
      icon: <Sparkles size={32} />,
      title: "Premium Quality",
      desc: "Designed for elegance, crafted with precision. Made with premium fabrics for style, comfort, and durability because you deserve the best.",
    },
    {
      icon: <Truck size={32} />,
      title: "Fast Delivery",
      desc: "We ensure quick and reliable shipping so your fashion arrives right on time.",
    },
    {
      icon: <ShieldCheck size={32} />,
      title: "Trusted Brand",
      desc: "Building trust with every order through quality products, honest service, and customer-first support.",
    },
    {
      icon: <Heart size={32} />,
      title: "Made With Passion",
      desc: "Driven by passion, we bring you carefully chosen styles that blend comfort, quality, and confidence.",
    },
  ];

  return (
    <section className="max-w-6xl mx-auto px-4">
      
      {/* Intro */}
      <div className="text-center mb-12">
        <p className="text-gray-600 max-w-5xl mx-auto">
          {webDetails?.brand_desc}
        </p>
      </div>

      {/* Feature Boxes */}
      <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-6">
        {features.map((item, i) => (
          <div
            key={i}
            className="bg-white rounded-xl shadow-md hover:shadow-xl transition p-6 text-center border"
          >
            <div className="flex justify-center text-primary mb-4">
              {item.icon}
            </div>

            <h3 className="font-semibold text-lg mb-2">{item.title}</h3>

            <p className="text-gray-500 text-sm">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutUs;